var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.apis.length > 0)?_c('div',[_c('CDropdown',{staticClass:"dropdown-api",attrs:{"placement":_vm.placement,"color":"primary","variant":"btn-group","togglerText":'ALTERAR NEGÓCIO'}},_vm._l((_vm.apis),function(api){return _c('CDropdownItem',{key:api.API_URL,on:{"click":function($event){return _vm.changeApi(api)}}},[_c('img',{staticClass:"api-icon",attrs:{"src":`${api.API_URL}/images/favicon/icon-72x72/s/ADMIN`,"alt":"Icone sistema"}}),_c('span',{staticClass:"api-name"},[_vm._v(" "+_vm._s(api.NAME)+" ")]),_c('span',{staticClass:"status-dot",class:{
          'status-dot-logged':
            _vm.hasTokenForApi(api) || api.API_URL === _vm.config.api,
          'status-dot-anonymous': !(
            _vm.hasTokenForApi(api) || api.API_URL === _vm.config.api
          ),
        },attrs:{"title":_vm.hasTokenForApi(api) || api.API_URL === _vm.config.api
            ? 'Sessão ativa nesta instalação'
            : 'Precisa fazer login'}})])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }